import { render, staticRenderFns } from "./partnerProductAccountPeriodEdit.vue?vue&type=template&id=64dc29e6&scoped=true&"
import script from "./partnerProductAccountPeriodEdit.vue?vue&type=script&lang=js&"
export * from "./partnerProductAccountPeriodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc29e6",
  null
  
)

export default component.exports